import React, { useEffect } from 'react';
import styled from 'styled-components';
import GroupMemberList from '../component/members/GroupMemberList';
import GroupMemberTopBar from '../component/members/GroupMemberTopBar';
import { useShortCut } from '../shared/hooks/useShortCut';
import { useGroupMemberContentModeStore } from '../shared/store/groupMemberContentModeStore';
import { GroupMemberContentMode } from '../shared/enum/EnumRepository';

const Members: React.FC = () => {
  const { handleCmdE, handleCmdSlash } = useShortCut();
  const setGroupMemberContentMode = useGroupMemberContentModeStore((s) => s.setGroupMemberContentMode);
  const groupMemberContentMode = useGroupMemberContentModeStore((s) => s.groupMemberContentMode);

  useEffect(() => {
    if (
      useGroupMemberContentModeStore.getState().groupMemberContentMode ===
      GroupMemberContentMode.ENG
    ) {
      setGroupMemberContentMode(GroupMemberContentMode.Orig);
    }
  }, [setGroupMemberContentMode]);

  return (
    <MembersContainer
      onKeyDown={(e) => {
        handleCmdE(e);
        handleCmdSlash(e, () => {
          setGroupMemberContentMode(
            groupMemberContentMode === GroupMemberContentMode.Orig
              ? GroupMemberContentMode.ENG
              : GroupMemberContentMode.Orig,
          );
        });
      }}
      tabIndex={-1}
    >
      <GroupMemberTopBar />
      <GroupMemberList />
    </MembersContainer>
  );
}

export default Members;

const MembersContainer = styled.main`
  width: 93%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  margin-bottom: 3vh;
  overflow: hidden;
`;
